import { IEmailType } from "containers/admin/clients/client/components/email-types/email-types.types";
import type { EmailAttributes } from "hooks/api/use-touchpoint-versions";

import { DEFAULT_SENDER_DATA } from "containers/admin/clients/client/components/email-types/email-types.constants";

export const getSenderOnEmailTypeChange = (
  emailType: IEmailType,
  currentTouchpointVersion: EmailAttributes,
) => {
  //check if we have senders at all
  if (emailType?.senders?.length) {
    let sender;

    if (emailType?.id !== currentTouchpointVersion?.iterableEmailTypeId) {
      //if another iterableEmailTypeId has been chosen - we set default sender
      sender = emailType?.senders.find((sndr) => sndr.defaultForEmailType)!;
    } else {
      if (currentTouchpointVersion.iterableEmailSenderId) {
        //is there is an iterableEmailSenderId
        //we set the sender that was chosen before
        sender = emailType?.senders.find(
          (sender) => sender.id === currentTouchpointVersion.iterableEmailSenderId,
        )!;
      } else {
        //if there is no iterableEmailSenderId but there are defined senders - we set default sender as well
        sender = emailType?.senders.find((sndr) => sndr.defaultForEmailType)!;
      }
    }

    return sender;
  } else {
    //if we don't have senders - we set a default sender
    return DEFAULT_SENDER_DATA;
  }
};
